import { Info } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

import { EmailTemplate } from './constants'
import { TemplateListItem } from './TemplateListItem'

type TemplateListProps = {
  templates: EmailTemplate[]
  selectedTemplate: EmailTemplate | null
  isTemplateEdited: (bodyField: string) => boolean
  onSelectTemplate: (template: EmailTemplate) => void
  title: string
}

export const TemplateList = ({
  templates,
  selectedTemplate,
  isTemplateEdited,
  onSelectTemplate,
  title,
}: TemplateListProps) => {
  const isCustomer = title.includes('Kunden')
  const isTenant = title.includes('Unternehmens')

  return (
    <div className={title !== 'Kunden-E-Mails (an Kunden gesendet)' ? 'pt-2' : ''}>
      <div className="flex items-center gap-2">
        <h4 className="text-md font-semibold">{title.replace(/\s*\([^)]*\)/, '')}</h4>
        {(isCustomer || isTenant) && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="bg-muted text-muted-foreground flex h-5 w-5 cursor-help items-center justify-center rounded-full">
                <Info className="h-3 w-3" />
              </div>
            </TooltipTrigger>
            <TooltipContent color="secondary">
              <p>{isCustomer ? 'Gesendet an Kunden' : 'Gesendet an Unternehmen'}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <ul className="space-y-2">
        {templates.map((template) => (
          <TemplateListItem
            key={template.key}
            template={template}
            isSelected={selectedTemplate?.key === template.key}
            isEdited={isTemplateEdited(template.bodyField as string)}
            onClick={() => onSelectTemplate(template)}
          />
        ))}
      </ul>
    </div>
  )
}
